export enum PaymentMethod {
    BankTransfer = "BankTransfer",
    Paypal = "Paypal",
    CreditCard = "CreditCard",
    ApplePay = "ApplePay",
    GooglePay = "GooglePay",
    PayByBank = "PayByBank"
}
